// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__ZNFNu","title":"ClientInsurance_title__1lrGt","itemText":"ClientInsurance_itemText__36BlM"};